import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const TrashCanFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function TrashCanFilled({
  title = 'Trash can',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Trash can'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M16 1v2h5v3H3V3h5V1h8ZM5 8h14v15H5V8Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default TrashCanFilled;